import { render, staticRenderFns } from "./comments-dropdown.vue?vue&type=template&id=7af11188&scoped=true"
import script from "./comments-dropdown.vue?vue&type=script&lang=js"
export * from "./comments-dropdown.vue?vue&type=script&lang=js"
import style0 from "./comments-dropdown.vue?vue&type=style&index=0&id=7af11188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af11188",
  null
  
)

export default component.exports